import React from "react";
import { Button, Stack } from "@mui/material";
import { Plus, Save } from "lucide-react";

export default function MasterFormActions({
  isEditing,
  onCancel,
  disabled = false,
  showCancel = true,
}: {
  isEditing: boolean;
  onCancel?: () => void;
  disabled?: boolean;
  showCancel?: boolean;
}) {
  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={1}
      justifyContent="flex-end"
      sx={{ mt: 2 }}
    >
      {showCancel && onCancel ? (
        <Button
          type="button"
          variant="outlined"
          color="inherit"
          onClick={onCancel}
          sx={{ color: "#5A5D76", borderColor: "#d6dee5" }}
        >
          Cancel
        </Button>
      ) : null}
      <Button
        type="submit"
        variant="contained"
        disabled={disabled}
        startIcon={isEditing ? <Save size={16} /> : <Plus size={16} />}
      >
        {isEditing ? "Update" : "Add"}
      </Button>
    </Stack>
  );
}
